// src/config/links.ts

export interface ToolLink {
  id: string;
  label: string;
  description: string;
  baseUrl: string;
  /**
   * Optional overrides for specific locations.
   * Keyed by OrgLocation.id (e.g. "lot_ravenel", "lot_moncks_corner").
   */
  perLocation?: Record<string, string>;
}

// Pilot org defaults (Bennett); future: org-configurable tool links per tenant.
export const TOOL_LINKS: ToolLink[] = [
  {
    id: "crm",
    label: "CRM (GoHighLevel)",
    description: "Primary CRM for all leads, pipelines, and follow-up.",
    baseUrl: "https://crm.buybennett.com",
  },
  {
    id: "salesview",
    label: "SalesView Configurators",
    description: "3D configurators and lot-specific product setups.",
    baseUrl: "https://salesview.idearoominc.com",
    // This is where you'd drop deep links for each lot as you have them:
    // perLocation: {
    //   lot_ravenel: "https://salesview.idearoominc.com/ravenel-configurator",
    //   lot_moncks_corner: "https://salesview.idearoominc.com/moncks-corner-configurator",
    //   // etc...
    // },
  },
  {
    id: "legacy_pos",
    label: "POS (inventory host)",
    description: "Inventory, sales agreements, and delivery workflows.",
    baseUrl: import.meta.env.VITE_LEGACY_POS_APP_URL?.trim() || "",
  },
  {
    id: "website",
    label: "Company website",
    description: "Public-facing website and location information.",
    baseUrl: "https://buybennett.com",
  },
  {
    id: "payments",
    label: "Authorize.net Payments",
    description: "Payment gateway for processing customer payments.",
    baseUrl: "https://account.authorize.net",
  },
];
